const scope_0 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/8512bacb91f3e72f76b8eeb2f5ea0da1.js').default;
const scope_1 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/8f9d02bf8e0d79ca28ae6364a48abda2.js').default;
const scope_2 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/a7e5c6c20245afd86ce1f18c31d620d0.js').default;
const scope_3 = require('/opt/build/repo/.cache/caches/gatsby-mdx/mdx-scopes-dir/de7fff38fdce903fadc0d777265077e6.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    